import {isArrayNullUndefinedOrEmpty, isNullOrUndefined} from "../../../services/Validator";
import {kInternalRoutes} from "../../../constants/internalRoutes";
import {useNavigate} from "react-router-dom";
import {Environment} from "../../../enums/Environment";
import {kFakeSingleLevelA} from "../../../services/Faker";
import {get_single_levelA_by_slug} from "../../../api/levelA";
import {kEmptyResponseError, kLevelAError} from "../../../constants/errors";
import {sendErrorToSentry} from "../../../services/Sentry";
import {useCallback, useEffect, useState} from "react";
import SystemAppContentError from "../../errors/SystemAppContentError";
import SystemAppContentLoader from "../../loaders/SystemAppContentLoader";
import LevelAMetaData from "./LevelAMetaData";
import LevelAKnowledge from "./LevelAKnowledge";
import LevelAExample from "./LevelAExample";
import LevelAExerciserSection from "./LevelAExerciserSection";
import LevelAFlashSection from "./LevelAFlashSection";

export default function LevelAContent({from, slug, isBrevetDisplay}) {
    // Used in LevelAScreen to display

    // PROPERTIES
    const navigate = useNavigate()
    // ---- LevelA
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const [levelA, setLevelA] = useState(null)

    // HOOKS
    // ---- Memorizes a function, preventing it from being redefined on every render, unless its dependencies change.
    const getLevelA = useCallback(() => {
        // <<<< For .env.faker ----
        if (process.env.REACT_APP_ENV === Environment.FAKER) {
            setLevelA(kFakeSingleLevelA)
            setIsLoading(false)
            setError(null)
            return
        }
        // ---- For .env.faker >>>>

        // Switch loader on and clear error
        setIsLoading(true)
        setError(null)
        // Perform
        get_single_levelA_by_slug(slug)
            .then((res) => {
                if (isNullOrUndefined(res) || isArrayNullUndefinedOrEmpty(res)) {
                    setError(kEmptyResponseError)
                    sendErrorToSentry(kEmptyResponseError.sentry, "fetching LevelA from LevelAScreen")
                } else {
                    setLevelA(res)
                }
            }).catch((err) => {
            console.error(err)
            setError(kLevelAError)
            sendErrorToSentry(kLevelAError.sentry, "LevelAScreen")
        }).finally(() => {
            setIsLoading(false)
        })
    }, [slug])
    // ---- Triggered at rendering : set Grades
    useEffect(() => {
        getLevelA()
    }, [getLevelA])

    // BUILD
    if (!isNullOrUndefined(error))
        return <SystemAppContentError error={error}
                                      isLoading={isLoading}
                                      retryCallback={() => getLevelA()} />
    if (isLoading)
        return <SystemAppContentLoader />
    return (
        <div className={"mt-[32px] grow animate-appearSlow w-full flex flex-col justify-start items-center px-[24px] pb-[32px]"}>
            <LevelAMetaData task={levelA.task}
                            brevet={levelA.brevet}
                            levelAGrade={levelA.levelAGrade}
                            levelASubtheme={levelA.levelASubtheme} />
            <LevelAKnowledge levelAKnowledge={levelA.levelAKnowledge}
                             isBrevetDisplay={isBrevetDisplay} />
            <LevelAExample levelAKnowledge={levelA.levelAKnowledge}
                           isBrevetDisplay={isBrevetDisplay} />
            <LevelAFlashSection isBrevetDisplay={isBrevetDisplay}
                                launchFlash={launchFlash} />
            <LevelAExerciserSection levelA={levelA}
                                    isBrevetDisplay={isBrevetDisplay}
                                    launchExerciser={launchExerciser} />
        </div>
    );

    // METHODS
    // ---- NAV : Launch flash with current LevelA
    function launchFlash() {
        if (!isNullOrUndefined(levelA?.id)) {
            navigate(kInternalRoutes.flash, {
                state: {
                    origin: from,
                    levelAId: levelA.id,
                }
            })
        }
    }

    // ---- NAV : Launch flash with current LevelA
    function launchExerciser() {
        if (!isNullOrUndefined(levelA?.identifier)) {
            navigate(kInternalRoutes.exerciser, {
                state: {
                    origin: from,
                    levelAIdentifier: levelA.identifier,
                }
            })
        }
    }
}